import { haversineDistance } from '@/shared/lib/distance';
import { getSafeCoords, isPointInGeoJsonPolygon, MaybeLatLon } from '@/shared/lib/geo';
import { CompleteVenue } from '../types/CompleteVenue';

/**
 * Returns venues that can deliver to an address, ordered by their distance from it.
 * Each returned item adds `matchedMethods` containing delivery methods whose areas contain the address.
 * Venues or addresses without valid coordinates are placed last.
 */
export const getDeliverableVenues = (
    venues: CompleteVenue[],
    address: MaybeLatLon | null,
    currentLocation?: MaybeLatLon,
    filterWhenNoAddress: boolean = true,
) => {
    return venues
        .map((venue) => {
            const latLon = getSafeCoords(venue.address);
            const addressLatLon = getSafeCoords(address);
            const currentLocationLatLon = getSafeCoords(currentLocation);
            const matchedMethods = venue.deliveryMethods.filter((method) =>
                !filterWhenNoAddress && !addressLatLon
                    ? (method.areas?.length ?? 0) !== 0
                    : method.areas?.some(
                          (area) => addressLatLon && isPointInGeoJsonPolygon(addressLatLon, area.geoJson),
                      ),
            );
            return {
                ...venue,
                matchedMethods,
                distance:
                    latLon && addressLatLon
                        ? haversineDistance(addressLatLon, latLon)
                        : latLon && currentLocationLatLon
                          ? haversineDistance(currentLocationLatLon, latLon)
                          : Infinity,
            };
        })
        .filter((item) => item.matchedMethods.length > 0)
        .sort((a, b) => a.distance - b.distance);
};
